import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

const V3Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="v3-footer">
      <div className="v3-footer-links">
        <Link to="/leadership-development">{t('common.navLeadership')}</Link>
        ·
        <Link to="/hyperlocal-platform">{t('common.navHyperlocal')}</Link>
        ·
        <Link to="/about">{t('common.navAbout')}</Link>
        ·
        <Link to="/privacy-policy">{t('common.privacy')}</Link>
        ·
        <Link to="/cookie-policy">{t('common.cookies')}</Link>
        ·
        <Link to="/terms-of-use">{t('common.terms')}</Link>
        ·
        <a href="#contact">{t('common.contact')}</a>
      </div>
      <div className="v3-footer-contact" id="contact">
        <p>{t('footer.address')}</p>
        <p>
          <a href={`tel:${t('footer.phone').replace(/\s/g, '')}`}>{t('footer.phone')}</a>
          {' · '}
          <a href={`mailto:${t('footer.email')}`}>{t('footer.email')}</a>
        </p>
      </div>
    </footer>
  );
};

export default V3Footer;
